module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 10.7242e196.png";